import type { Translation } from '../../types';
import type { dns as en } from '../en/dns';

/** Vùng DNS của tên miền (tab DNS của trang tên miền). Lời thường, không dùng mã. */
export const dns: Translation<typeof en> = {
  ns: {
    title: 'Vùng DNS',
    kind: {
      TINO: 'Máy chủ tên mặc định của Tino',
      PARKED: 'Đang đỗ',
      EXTERNAL: 'Máy chủ tên bên ngoài',
      NONE: 'Chưa có máy chủ tên',
    },
    kindHint: {
      TINO: 'Tên miền dùng máy chủ tên mặc định của Tino ({{list}}).',
      PARKED: 'Tên miền đang dùng cặp máy chủ tên đỗ ({{list}}) cho tới khi được gia hạn.',
      EXTERNAL: 'Tên miền dùng máy chủ tên ngoài Tino ({{list}}).',
      NONE: 'Chưa ghi nhận máy chủ tên nào cho tên miền.',
    },
    kindUnknown: 'Máy chủ tên: {{list}}. Không xác định được loại vì không đọc được bộ máy chủ tên mặc định và cặp đỗ của Tino.',
  },
  noZone: {
    TINO: 'Hệ thống chưa giữ vùng DNS của tên miền này. Bản ghi đang nằm trên máy chủ tên của Tino, ngoài hệ thống: sửa tại đó.',
    PARKED: 'Cặp máy chủ tên đỗ đang trả lời cho tên miền; hệ thống không giữ vùng DNS của tên miền này.',
    EXTERNAL: 'Bản ghi do nơi vận hành máy chủ tên đó giữ; hệ thống không giữ vùng DNS của tên miền này.',
    NONE: 'Hệ thống không giữ vùng DNS của tên miền này.',
  },
  loadFailed: 'Không đọc được vùng DNS',
  zone: {
    title: 'Bản ghi DNS',
    hint: 'Vùng DNS hệ thống giữ cho tên miền. Mỗi thay đổi cần lý do, thành một phiên bản mới và được gửi tới máy chủ DNS.',
    service: 'Vùng',
    module: 'Module',
    state: 'Trạng thái dịch vụ',
    dnssec: 'DNSSEC',
    nameservers: 'Máy chủ tên của vùng',
    notYet: 'Chưa biết',
    secondary: 'Vùng phụ: bản ghi lấy từ máy chủ chính.',
    notPointed: 'Tên miền chưa dùng máy chủ tên của vùng ({{list}}): bản ghi sửa ở đây chưa có hiệu lực cho tới khi tên miền trỏ về.',
  },
  login: {
    title: 'Đăng nhập DNS của tên miền',
    hint: 'Khách của đại lý quản lý vùng này bằng tên miền và mật khẩu DNS riêng, không cần tài khoản. Đổi hoặc thu hồi mật khẩu sẽ đăng xuất mọi phiên đang mở.',
    none: 'Vùng chưa có đăng nhập DNS.',
    state: 'Đăng nhập DNS',
    on: 'Đang bật',
    setBy: 'Người đặt',
    byStaff: 'Nhân viên',
    byCustomer: 'Khách hàng (chủ tài khoản)',
    setAt: 'Đặt lúc',
    sessions: 'Phiên đang mở',
    set: 'Đặt mật khẩu DNS',
    replace: 'Đổi mật khẩu DNS',
    revoke: 'Thu hồi đăng nhập DNS',
    setBody: 'Khách sẽ đăng nhập bằng tên miền và mật khẩu này để quản lý vùng.',
    replaceBody: 'Mật khẩu cũ hết hiệu lực và mọi phiên đang mở bị đăng xuất.',
    password: 'Mật khẩu DNS',
    passwordHint: 'Từ 12 đến 128 ký tự. Hệ thống đã tạo sẵn một mật khẩu mạnh; hãy chép lại trước khi lưu vì sẽ không hiển thị lại.',
    generate: 'Tạo mật khẩu khác',
    save: 'Lưu mật khẩu',
    done: 'Đã lưu mật khẩu',
    doneHint: 'Gửi cho khách qua kênh an toàn; hệ thống sẽ không hiển thị lại mật khẩu này.',
    revokeBody: 'Không ai đăng nhập được bằng mật khẩu DNS nữa và mọi phiên đang mở bị đăng xuất. Vùng và bản ghi vẫn giữ nguyên.',
    revoked: 'Đã thu hồi đăng nhập DNS.',
  },
  dnssecState: {
    OFF: 'Tắt',
    ENABLING: 'Đang bật',
    ON: 'Bật',
    DISABLING: 'Đang tắt',
  },
  status: {
    applied: 'Đã áp dụng phiên bản {{version}} trên máy chủ DNS.',
    waiting: 'Chờ gửi tới máy chủ DNS: phiên bản {{desired}} (máy chủ đang giữ phiên bản {{applied}}).',
    waitingFirst: 'Chờ gửi tới máy chủ DNS: phiên bản {{desired}} (chưa gửi lần nào).',
    refused: 'Máy chủ DNS từ chối thay đổi gần nhất: {{detail}}',
    failed: 'Lần gửi gần nhất không thành công: {{detail}}',
    unknown: 'Lần gửi gần nhất chưa có kết quả; đang đối chiếu với máy chủ DNS.',
  },
  col: {
    name: 'Tên',
    type: 'Loại',
    ttl: 'TTL',
    value: 'Giá trị',
    source: 'Nguồn',
  },
  source: {
    customer: 'Khách hàng',
    email: 'E-mail',
    website: 'Website',
    cloud: 'Máy chủ đám mây',
    hosting: 'Hosting',
    other: 'Dịch vụ {{owner}}',
  },
  readOnly: 'Do {{source}} tạo: thay đổi theo dịch vụ đó.',
  empty: 'Vùng chưa có bản ghi nào.',
  action: {
    add: 'Thêm bản ghi',
    edit: 'Sửa',
    remove: 'Xoá',
    export: 'Tệp vùng',
    import: 'Nhập tệp vùng',
    template: 'Áp mẫu',
    rollback: 'Quay lại phiên bản này',
  },
  form: {
    name: 'Tên',
    nameHint: '@ là chính tên miền, hoặc một tên bên dưới (www, mail, _dmarc).',
    type: 'Loại',
    ttl: 'TTL (giây)',
    values: 'Giá trị',
    valuesHint: 'Mỗi dòng một bản ghi, ví dụ "10 mail.example.vn." cho MX. Tên không có dấu chấm cuối được hiểu đúng như đã viết.',
    txtHint: 'Văn bản không có dấu ngoặc kép sẽ được tự thêm (văn bản dài được chia thành từng đoạn 255 ký tự).',
    others: 'Cùng tên và loại này còn có bản ghi do dịch vụ khác giữ (được giữ nguyên): {{list}}',
    addTitle: 'Thêm bản ghi',
    editTitle: 'Sửa {{name}} {{type}}',
    removeTitle: 'Xoá {{name}} {{type}}',
    removeBody: 'Xoá các bản ghi {{name}} {{type}} của khách hàng. Bản ghi do dịch vụ khác tạo được giữ nguyên.',
    save: 'Lưu',
    removeSubmit: 'Xoá',
    violations: 'Bản ghi chưa đúng quy tắc:',
    done: 'Đã lưu thành phiên bản {{version}}.',
    unchanged: 'Không có gì thay đổi.',
  },
  exportForm: {
    title: 'Tệp vùng',
    hint: 'Vùng dưới dạng tệp vùng RFC 1035, lấy từ bản ghi hệ thống đang giữ.',
    download: 'Tải tệp',
  },
  importForm: {
    title: 'Nhập tệp vùng',
    text: 'Tệp vùng (RFC 1035)',
    mode: 'Cách nhập',
    replace: 'Thay toàn bộ bản ghi của khách hàng',
    merge: 'Chỉ thay các tên và loại có trong tệp',
    skipped: 'Không nhập ({{count}}):',
    warnings: 'Lưu ý:',
    done: 'Đã nhập thành phiên bản {{version}}.',
    skippedReason: {
      APEX_NS: 'máy chủ tên của chính vùng (do máy chủ DNS giữ)',
      DNSSEC: 'bản ghi DNSSEC (máy chủ DNS tự tạo khi ký)',
      UNSUPPORTED_TYPE: 'loại bản ghi hệ thống không giữ',
    },
  },
  templateForm: {
    title: 'Áp mẫu vùng',
    template: 'Mẫu',
    mode: 'Cách áp',
    merge: 'Thêm vào bản ghi hiện có (nhóm trùng tên và loại được thay)',
    replace: 'Thay toàn bộ bản ghi của khách hàng',
    done: 'Đã áp mẫu thành phiên bản {{version}}.',
  },
  templates: {
    web: { name: 'Website (IPv4)', description: 'Tên miền trỏ về một địa chỉ, www là bí danh của tên miền.' },
    'no-mail': { name: 'Tên miền không gửi, không nhận thư', description: 'MX rỗng (RFC 7505), SPF không cho máy chủ nào gửi, DMARC từ chối.' },
    'caa-letsencrypt': { name: "Chỉ nhận chứng thư từ Let's Encrypt", description: "Chỉ Let's Encrypt được cấp chứng thư; báo cáo gửi về một địa chỉ e-mail." },
  },
  vars: {
    ipv4: 'Địa chỉ IPv4',
    report_email: 'E-mail nhận báo cáo',
  },
  versions: {
    title: 'Phiên bản',
    hint: 'Mỗi lần đổi bản ghi được lưu nguyên vẹn; quay lại cũng tạo một phiên bản mới.',
    col: { version: 'Phiên bản', reason: 'Loại thay đổi', staffReason: 'Lý do', note: 'Ghi chú', by: 'Người làm', at: 'Thời điểm' },
    system: 'Hệ thống',
    current: 'đang dùng',
    toVersion: 'về phiên bản {{version}}',
    rollbackTitle: 'Quay lại phiên bản {{version}}',
    rollbackBody: 'Bản ghi của khách hàng trở lại như phiên bản {{version}}, lưu thành phiên bản mới. Bản ghi do dịch vụ khác tạo giữ như hiện tại.',
    done: 'Đã quay lại phiên bản {{from}}, thành phiên bản {{version}}.',
    rollbackRecords: 'Bản ghi của khách hàng trong phiên bản {{version}}:',
    rollbackEmpty: 'Phiên bản {{version}} không có bản ghi nào của khách hàng: quay lại sẽ xoá toàn bộ bản ghi của khách hàng.',
  },
  reason: {
    CREATE: 'Tạo vùng',
    EDIT: 'Sửa bản ghi',
    IMPORT: 'Nhập từ tệp vùng',
    TEMPLATE: 'Áp mẫu',
    ROLLBACK: 'Quay lại phiên bản cũ',
    PUBLISH: 'Dịch vụ thêm bản ghi',
    WITHDRAW: 'Gỡ bản ghi theo dịch vụ',
  },
  ops: {
    title: 'Gửi tới máy chủ DNS',
    col: { op: 'Thao tác', status: 'Trạng thái', attempts: 'Số lần thử', at: 'Xếp hàng lúc', detail: 'Chi tiết' },
  },
  opName: {
    create: 'Tạo vùng',
    apply: 'Áp dụng bản ghi',
    repair: 'Sửa chỗ lệch',
    dnssec_enable: 'Bật DNSSEC',
    dnssec_disable: 'Tắt DNSSEC',
    allow_transfer: 'Cho phép sao chép vùng',
    native_template: 'Áp mẫu của máy chủ',
    suspend: 'Tạm ngưng',
    unsuspend: 'Mở lại',
    terminate: 'Gỡ vùng',
    change_plan: 'Đổi gói',
    renew: 'Gia hạn',
  },
  op: {
    QUEUED: 'Chờ gửi',
    SENDING: 'Đang gửi',
    RUNNING: 'Máy chủ đang xử lý',
    SUCCEEDED: 'Đã xong',
    REFUSED: 'Bị từ chối',
    FAILED: 'Không thành công',
    UNKNOWN: 'Chưa có kết quả',
    CANCELLED: 'Đã huỷ',
  },
  rule: {
    CAA_FLAGS: 'Cờ CAA chỉ là 0 hoặc 128.',
    CAA_IODEF: 'iodef phải là địa chỉ mailto: hoặc https://.',
    CAA_TAG: 'Thẻ CAA chỉ là issue, issuewild hoặc iodef.',
    CAA_VALUE: 'issue phải là tên miền của nhà cấp chứng thư, hoặc dấu ;.',
    CNAME_AT_APEX: 'Chính tên miền (@) không đặt được CNAME.',
    CNAME_EXCLUSIVE: 'Tên đã có CNAME thì không có bản ghi nào khác.',
    CNAME_SINGLE: 'Mỗi tên chỉ có một CNAME.',
    CNAME_TARGET: 'CNAME phải trỏ tới một tên.',
    DUPLICATE: 'Một bản ghi bị nhập hai lần.',
    DUPLICATE_SET: 'Có hai nhóm bản ghi trùng tên và loại.',
    EMPTY: 'Nhóm bản ghi phải có ít nhất một bản ghi.',
    MX_TARGET: 'Máy chủ thư phải là tên máy.',
    NAME: 'Tên không hợp lệ trong vùng này.',
    NS_AT_APEX: 'Máy chủ tên của chính vùng do máy chủ DNS giữ, không sửa ở đây.',
    NS_TARGET: 'Máy chủ tên phải là tên máy.',
    NULL_MX: 'MX rỗng ("0 .") phải đứng một mình.',
    OCCLUDED: 'Tên nằm dưới một tên đã ủy quyền (NS) nên sẽ không bao giờ được trả lời.',
    PTR_ZONE: 'Bản ghi PTR chỉ thuộc vùng ngược (in-addr.arpa, ip6.arpa).',
    SRV_NAME: 'Tên SRV có dạng _dịch-vụ._giao-thức[.tên].',
    SRV_NULL: '"Không có dịch vụ" (đích .) phải đứng một mình.',
    TLSA_DATA: 'Độ dài mã băm không khớp loại băm.',
    TLSA_FIELDS: 'Trường usage 0–3, selector 0–1, matching type 0–2 chưa đúng.',
    TLSA_NAME: 'Tên TLSA có dạng _cổng._giao-thức[.máy].',
    TOO_MANY: 'Quá nhiều bản ghi trong một nhóm.',
    TTL: 'TTL nằm ngoài giới hạn cho phép.',
    TXT_LENGTH: 'Mỗi chuỗi văn bản tối đa 255 byte.',
    TXT_TOTAL: 'Bản ghi văn bản quá dài.',
    TYPE_MISMATCH: 'Có giá trị khác loại trong nhóm.',
    WILDCARD_NS: 'Tên đại diện (*) không ủy quyền (NS) được.',
    ZONE_SIZE: 'Vùng có quá nhiều nhóm bản ghi.',
  },
};
